// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Kkj8","update":"styles_update__2M7yq","updateText":"styles_updateText__UyhVa"};